/**
 * Module dependencies.
 */

import { Typography, css } from '@mui/material';
import { color } from 'styles/utils/colors';
import { switchProp } from 'styled-tools';
import styled from '@emotion/styled';

/**
 * Export `Wrapper` styled component.
 */

export const Wrapper = styled.div``;

/**
 * Export `Title` styled component.
 */

export const Title = styled(Typography)<{
  level?: 'primary' | 'secondary' | 'terciary';
}>`
  font-weight: 600;
  font-size: 13px;

  ${({ theme }) =>
    switchProp('level', {
      primary: css`
        color: ${color('primary500')({ theme })};
      `,
      secondary: css`
        color: ${color('primary300')({ theme })};
      `,
      terciary: css`
        color: ${color('primary100')({ theme })};
      `,
    })}
`;

/**
 * Export `Content` styled component.
 */

export const Content = styled.div`
  margin-top: 8px;
  margin-bottom: 24px;
`;
